namespace $ {
	$.$mol_env = function $mol_env() {
		return this.process.env
	}
}
